import { UIDeviceController } from '../../shared/scripts/ui_html/UIDeviceController.ts';
import { StorageWrapper } from '../../shared/scripts/StorageWrapper.ts';
export var UIMGameMode = /*#__PURE__*/ function(UIMGameMode) {
    UIMGameMode[UIMGameMode["LANDSCAPE"] = 0] = "LANDSCAPE";
    UIMGameMode[UIMGameMode["PORTRAIT"] = 1] = "PORTRAIT";
    return UIMGameMode;
}({});
export class UIMGameOrientationController {
    static disableLandscapeMode() {
        const isTabletPlayer = UIDeviceController.isUserOnTabletApp();
        if (isTabletPlayer) return;
        StorageWrapper.setPortraitGamePlayEnabled(true);
        this.hideLandscapeModeToggle();
    }
    static hideLandscapeModeToggle() {
        const landscapeToggle = document.getElementById('m-menu-game-mode');
        landscapeToggle === null || landscapeToggle === void 0 ? void 0 : landscapeToggle.classList.add('hidden');
    }
    static setPortraitModeForNewPlayers() {
        const isOnMobileWeb = UIDeviceController.isUserOnMobileWebBrowser();
        const shouldResetOrientation = StorageWrapper.shouldResetGameOrientation();
        const shouldSetPortraitMode = isOnMobileWeb || shouldResetOrientation;
        if (!shouldSetPortraitMode) return;
        StorageWrapper.setPortraitGamePlayEnabled(true);
    }
    constructor(){
        UIMGameOrientationController.setPortraitModeForNewPlayers();
        UIMGameOrientationController.disableLandscapeMode();
        StorageWrapper.clearDeprecationStorage();
    }
}
